import React from "react";
import PropTypes from "prop-types";
import {
  DialogTitle,
  DialogTitleActions,
  ContentFormatter,
  Dialog,
} from "@ebscois/react-component-library";

import { HfcDialogTitle, HfcDialogContent } from "./_.styled";

const ContentHFCDialog = ({ isOpen, onCancel, dialogTitle, dialogContent }) => (
  <Dialog isOpen={isOpen} maxWidth="lg" hasMaxHeight onRequestClose={onCancel}>
    <DialogTitle paddingBottom="sm">
      <HfcDialogTitle
        element="h2"
        fontFamily="secondary"
        color="gray800"
        marginTop="md"
        marginLeft="md"
      >
        {dialogTitle}
      </HfcDialogTitle>
      <DialogTitleActions onRequestClose={onCancel} isFloating />
    </DialogTitle>
    <HfcDialogContent>
      <ContentFormatter children={dialogContent} />
    </HfcDialogContent>
  </Dialog>
);

ContentHFCDialog.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  dialogTitle: PropTypes.string,
  dialogContent: PropTypes.string,
};

ContentHFCDialog.defaultProps = {
  isOpen: false,
};

ContentHFCDialog.displayName = "ContentHFCDialog";

export default ContentHFCDialog;
